require('./$.species')(Array);


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-es6-polyfill/~/core-js/modules/es6.array.species.js
 ** module id = 535
 ** module chunks = 0
 **/